module.exports = __webpack_public_path__ + "img/2.9bcbef65.png";